import React from 'react';
import styled from 'styled-components';
import HeaderTwo from '../parts/HeaderTwo';
import LinkButton from '../parts/LinkButton';

type SearchPrefectureCafeProps = {
  backgroundColor?: string;
}

const SearchPrefectureCafeStyle = styled.div<{ $backgroundColor?: string }>`
  background: ${props => props.$backgroundColor || 'white'};
  padding: 60px 30px 60px 30px;

  @media (max-width: 768px) {
    padding: 30px 10px 30px 10px;
  }
`;

const UseCaseLinkButtonStyle = styled(LinkButton)`
  margin-right: 10px;
  margin-bottom: 10px;
`;

const SearchPrefectureCafe: React.FC<SearchPrefectureCafeProps> = ({ backgroundColor }) => {
  return (
    <SearchPrefectureCafeStyle $backgroundColor={backgroundColor}>
      <HeaderTwo mb='20px'>都道府県から探す</HeaderTwo>
      <UseCaseLinkButtonStyle href={`/shops?area=東京都`}>東京都</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=北海道`}>北海道</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=青森県`}>青森県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=岩手県`}>岩手県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=宮城県`}>宮城県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=秋田県`}>秋田県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=山形県`}>山形県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=福島県`}>福島県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=神奈川県`}>神奈川県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=埼玉県`}>埼玉県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=千葉県`}>千葉県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=茨城県`}>茨城県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=栃木県`}>栃木県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=群馬県`}>群馬県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=山梨県`}>山梨県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=新潟県`}>新潟県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=富山県`}>富山県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=石川県`}>石川県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=福井県`}>福井県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=長野県`}>長野県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=静岡県`}>静岡県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=愛知県`}>愛知県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=岐阜県`}>岐阜県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=三重県`}>三重県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=滋賀県`}>滋賀県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=京都府`}>京都府</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=大阪府`}>大阪府</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=兵庫県`}>兵庫県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=奈良県`}>奈良県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=和歌山県`}>和歌山県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=鳥取県`}>鳥取県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=島根県`}>島根県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=岡山県`}>岡山県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=広島県`}>広島県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=山口県`}>山口県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=徳島県`}>徳島県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=香川県`}>香川県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=愛媛県`}>愛媛県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=高知県`}>高知県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=福岡県`}>福岡県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=佐賀県`}>佐賀県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=長崎県`}>長崎県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=熊本県`}>熊本県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=大分県`}>大分県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=宮崎県`}>宮崎県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=鹿児島県`}>鹿児島県</UseCaseLinkButtonStyle>
      <UseCaseLinkButtonStyle href={`/shops?area=沖縄県`}>沖縄県</UseCaseLinkButtonStyle>
    </SearchPrefectureCafeStyle>
  );
};

export default SearchPrefectureCafe;
